import { Heatmap as HeatmapLayer } from 'ol/layer';
import { Vector as VectorSource, Cluster as ClusterSource } from 'ol/source';
import Feature from 'ol/Feature';
export default {
  methods: {
    getClusterSource(source, weight) {
      return new ClusterSource({
        distance: 1,
        source,
        createCluster: (point, features) => {
          return new Feature({
            geometry: point,
            features,
            ...(weight
              ? { [weight]: features.map(feature => feature.get(weight)).reduce((a, b) => a + b, 0) / features.length }
              : {}),
          });
        },
      });
    },
    async toggleHeatmap({ layerId, params = {}, features } = {}) {
      params = {
        ...{
          radius: 2,
          blur: 5,
          weight: '',
          gradient: ['#ffffb2', '#fecc5c', '#fd8d3c', '#f03b20', '#bd0026'],
        },
        ...params,
      };
      const heatmapLayer = this.getLayerById('heatmap');
      if (!layerId) heatmapLayer?.getSource()?.getSource()?.clear(true);
      const vectorSource = heatmapLayer?.getSource()?.getSource() || new VectorSource({});
      if (features) {
        vectorSource.clear(true);
        vectorSource.addFeatures(features);
      }
      const clusterSource = this.getClusterSource(vectorSource, params.weight);
      if (heatmapLayer) {
        heatmapLayer.setSource(clusterSource);
        heatmapLayer.setRadius(params.radius);
        heatmapLayer.setBlur(params.blur);
        heatmapLayer.setWeight(params.weight || '');
        heatmapLayer.changed();
      } else {
        const heatmap = new HeatmapLayer({
          id: 'heatmap',
          source: clusterSource,
          layer_id: layerId,
          ...params,
        });
        this.map.addLayer(heatmap);
      }
    },
  },
  mounted() {
    this.$root.$on('toggleHeatmap', this.toggleHeatmap);
  },
};
